import request from 'local_modules/request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { constants, modals } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.customerLearnPage.setFetching(isFetching)

const setStep = (step) => reducers.marketplace.customerLearnPage.setStep(step)

const setStepData = (stepData) => reducers.marketplace.customerLearnPage.setStepData(stepData)

const clearTotal = () => {
  reducers.marketplace.customerLearnPage.setTotalFetching(true)
  reducers.marketplace.customerLearnPage.setTotal(null)
}

const findSubscriber = ({ groupId, firstName, lastName, middleName, email }) => {
    const { marketplace: { layersNavigation: { tool } } } = getState()

    return request.post(constants.marketplace.learnGroupBooking + `/${groupId}/search`, {
      firstName,
      lastName,
      middleName,
      email,
    })
    .then(({ data }) => data)
    .then((data) => {
      const { status, errormsg } = data || {}

      if (!errormsg) {
        reducers.marketplace.customerLearnPage.setSubscriber({ ...data, groupId })
      }

      return data
    })
    .catch((error) => console.log(error))
}

const fetchGroups = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learn + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      if (data && data.length) {
        return data.filter(({ active } = {}) => active)
      }

      return data
    })
    .then((data) => {
      reducers.marketplace.customerLearnPage.setGroups(data)
      return data
    })
    .catch((error) => console.log(error))
}

const setRedirectUrlData = ({ id, email, groupId }) => {
  reducers.marketplace.customerLearnPage.setRedirectUrlData({ id, email, groupId })
}

const fetchTotal = ({ data, groupId }) => {
  const { activeMember, birth, contractNum, email, firstName, gender, id, lastName, middleName } = data

  reducers.marketplace.customerLearnPage.setTotalFetching(true)

  return request.post(constants.marketplace.learnGroupBooking + `/${groupId}/total`, { id })
    .then(({ data }) => data)
    .then(({ status, errormsg, total, accrued, recalcCount, nextMonth }) => {
      reducers.marketplace.customerLearnPage.setTotalFetching(false)

      if (status === 0) {
        reducers.marketplace.customerLearnPage.setTotal(total)
        reducers.marketplace.customerLearnPage.setAccrued(accrued)
        reducers.marketplace.customerLearnPage.setRecalcCount(recalcCount)

        if (nextMonth && nextMonth.learnGroup && nextMonth.learnGroup.currentSchedule && nextMonth.learnGroup.currentSchedule.toMonth) {
          reducers.marketplace.customerLearnPage.setToMonth(nextMonth.learnGroup.currentSchedule.toMonth)
        }
      }
      else if (errormsg) {
        actions.modals.open(modals.Dialog, {
          title: 'Ошибка',
          text: errormsg,
        })
      }
    })
    .catch((error) => console.log(error))
}

const fetchRedirectUrl = ({ newEmail } = {}) => {
  const { marketplace: { customerLearnPage: { redirectUrlData: { id, email, groupId } } } } = getState()

  return request.post(constants.marketplace.learnGroupBooking + `/${groupId}/book`, { id, email: newEmail || email })
    .then(({ data }) => data)
    .then(({ status, errormsg, redirectUrl }) => {
      if (status === 0) {
        reducers.marketplace.customerLearnPage.setRedirectUrl(redirectUrl)

        return redirectUrl
      }
      else if (errormsg) {
        actions.modals.open(modals.Dialog, {
          title: 'Ошибка',
          text: errormsg,
        })
      }
    })
    .catch((error) => console.log(error))
}

const handlePayment = (data) => {
  const {
    marketplace: {
      customerLearnPage: { trainersParams },
      // layersNavigation: { tool },
    },
  } = getState()
  const { firstName, middleName, lastName, trainer, count, email, phone, gender, label, birthInt } = data

  actions.ui.showRequestLoader('Не закрывайте окно, ваш запрос на оплату обрабатывается')

  return request.post(constants.marketplace.booking, {
    tariffCategory: { id: trainersParams.category.id },
    trainer: { id: trainer.id, quota: count },
    subscriber: {
      firstName, middleName, lastName,
      gender, label, birthInt,
      email,
      // phone, // temporary remove phone field
    },
  })
    .then(({ data }) => data)
    .then((data) => {
      const {
        status,
        errormsg,
        redirectUrl,
      } = data || {}

      if (errormsg) {
        actions.ui.hideRequestLoader()
        actions.modals.open(modals.Dialog, {
          title: 'Оплата не прошла',
          text: errormsg,
        })
      }
      else if (redirectUrl) {
        window.location.href = redirectUrl
      }
      else {
        console.log(data)
        actions.ui.hideRequestLoader()
      }

      return data
    })
    .catch((error) => {
      console.log(error)
      actions.ui.hideRequestLoader()
    })
}


export default {
  setFetching,
  setStepData,
  setStep,
  clearTotal,
  fetchTotal,
  fetchGroups,
  findSubscriber,
  handlePayment,
  fetchRedirectUrl,
  setRedirectUrlData,
}
